export default function getFormattedPriceFromOrder(order) {
    return (
        order.products.reduce((a, v) => { return a + (v.product_price * v.product_quantity) }, 0) +
        ((order.cash_on_delivery_fee === 0 && !order.bank_transfer)? 1.5 : order.cash_on_delivery_fee) +
        order.transport_fee
    ).toFixed(2)
}